import { defineComponent } from 'vue';

export default defineComponent({
  name: 'home-slider',
  computed: {
    tyreRangeRoute(){
      return this.$route.name == 'tyre-range' ? '1' :'0'
    }
  }
});